import * as React from 'react';
import { useDebouncedCallback } from './use-debounced-callback';
/**
 * use `MutationObserver` to force rerender when subtree changes.
 */
export const useForceUpdateOnSubtreeChange = (target, { init = defaultInit, cbDelay = 200, } = {}) => {
    const [, forceUpdate] = React.useState();
    const mutationCb = useDebouncedCallback(forceUpdate, cbDelay);
    const observerRef = React.useRef();
    React.useEffect(() => {
        const observer = new MutationObserver(mutationCb);
        observerRef.current = observer;
        return () => {
            observerRef.current = undefined;
        };
    }, []);
    React.useEffect(() => {
        const observer = observerRef.current;
        if (observer && target.current) {
            observer.observe(target.current, init);
            return () => observer.disconnect();
        }
    }, [init]);
};
const defaultInit = {
    childList: true,
    attributes: true,
    subtree: true,
    characterData: true,
};
//# sourceMappingURL=use-on-subtree-change.js.map